import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { FsDialogModule } from '@firestitch/dialog';

import { EnvironmentCreate } from '../../interfaces';
import { AddressComponent } from '../address/address.component';
import { ContactInfoComponent } from '../contact-info/contact-info.component';
import { DiseasesComponent } from '../diseases/diseases.component';
import { OrganizationNameComponent } from '../organization-name/organization-name.component';
import { ProgressComponent } from '../progress/progress.component';


@Component({
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FsDialogModule,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatCard,
    MatCardContent,
    OrganizationNameComponent,
    AddressComponent,
    ContactInfoComponent,
    DiseasesComponent,
    ProgressComponent,
  ],
})
export class CreateComponent implements OnInit {

  public environmentCreate: EnvironmentCreate = {
    address: {},
  };
  public step = 0;
  
  private _dialogRef = inject<MatDialogRef<CreateComponent>>(MatDialogRef);


  public ngOnInit(): void {
    this._dialogRef
      .addPanelClass('full-width-dialog')
      .addPanelClass('environment-create');
  }

  public stepNext(): void {
    this.step ++;
  }

  public close(): void {
    this._dialogRef.close();
  }

}
